enum OntarioPatientEnrollmentTerminationReasonCode {
    HealthNumberError = 12,
    PatientIdentifiedAsDeceasedOnMinistryDatabase = 14,
    PatientAddedToRosterInError = 24,
    MemberNowEnrolledWithRedAndWhiteHealthCard = 30,
    MemberNowEnrolledWithPhotoHealthCard = 32,
    ConfidentialCode33 = 33,
    PatientTransferredFromRosterPerPhysicianRequest = 35,
    PatientNowReEnrolled = 36,
    PatientNowEnrolledAsLongTermCare = 37,
    PatientLongTermCareEnrollmentEnded = 38,
    MemberRosterTransferredPerPhysicianRequest = 39,
    PhysicianReportedMemberAsDeceased = 40,
    PatientAssignedToAnotherPhysician = 41,
    PatientEnteredLongTermCareFacility = 42,
    PhysicianEndedPatientEnrollment = 44,
    PatientNoLongerMeetsSelectionCriteriaForRoster = 51,
    PatientMovedOutOfGeographicArea = 53,
    PatientLeftProvince = 54,
    PerPatientRequest = 56,
    EnrollmentTerminatedByPatient = 57,
    PatientOutOfGeographicArea = 59,
    NoCurrentEligibilityCode60 = 60,
    AppliedAddressOverrideForPatientOutOfArea = 61,
    RemovedAddressOverrideForPatientOutOfArea = 62,
    NoCurrentEligibilityCode73 = 73,
    NoCurrentEligibilityCode74 = 74,
    EnrollmentOrConsentFormNotReceivedByMinistry = 82,
    ConfidentialialCode84 = 84,
    ConfidentialialCode90 = 90,
    ConfidentialialCode91 = 91
}

export { OntarioPatientEnrollmentTerminationReasonCode };
